module.exports = __webpack_public_path__ + "static/media/R&R_-set-4.6835709e.jpg";